import { useState } from "react";
import './App.css'

import Header from './components/header/Header.jsx'
import Home from './components/home/Home.jsx'
import About from './components/about/About.jsx'
import Services from './components/services/Services.jsx'
import Contact from './components/contact/Contact.jsx'
import Lightbox from "./components/lightbox/Lightbox.jsx"
import Footer from './components/footer/Footer.jsx';


const App = () => {

  const [ lightboxOpened, setLightboxOpened ] = useState(false)
  const [ lightboxContentState, setLightboxContentState ] = useState(null)
  const [ lightboxTitle, setLightboxTitle ] = useState(null)

  const closeLightbox = () => 
  {
    setLightboxOpened(false)
  }

  const setLightboxParameters = ( title, state ) =>
  {
    setLightboxTitle( title )
    setLightboxContentState( state )
    setLightboxOpened(true)
  }

  return (
    <>
      <Header openLightbox={setLightboxParameters} />

      <main className='main'>
        <Home />
        <About openLightbox={setLightboxParameters} />
        <Services openLightbox={setLightboxParameters} />
        <Contact />
        <Footer />
      </main>

      { lightboxOpened ? <Lightbox title={lightboxTitle} lightboxContent={lightboxContentState} closeLightbox={closeLightbox} /> : null }
    </>
  )
}

export default App
